.panel {
  width: 380px;
}

.panelHeader {
  padding: var(--ant-padding-sm) var(--ant-padding) 0;
}

.headerDivider {
  margin: var(--ant-margin-xs) 0 0;
}

.listContainer {
  max-height: 440px;
  overflow-y: auto;
}

.skeletonItem {
  padding: var(--ant-padding-sm) var(--ant-padding);
  border-bottom: var(--ant-line-width) solid var(--ant-color-border-secondary);
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ant-margin-xs);
  padding: var(--ant-padding-xl) var(--ant-padding);
}

.emptyIcon {
  font-size: var(--ant-font-size-heading-3);
  color: var(--ant-color-text-quaternary);
}

.inboxButton:global(.ant-btn) {
  color: var(--ant-color-text-secondary);
}

.inboxButton:global(.ant-btn):hover {
  color: var(--ant-color-primary);
  background: var(--ant-color-primary-bg);
}

.popoverOverlay :global(.ant-popover-inner) {
  padding: 0;
  border-radius: var(--ant-border-radius-lg);
  overflow: hidden;
}
